import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import logo from "../../../assets/img/logo.png";
import { actions } from "../../../redux/actions";
import { Container } from "./styles";

export default function Sidebar() {
    const dispatch = useDispatch();
    const location = useLocation();
    const {menuOpen} = useSelector(
        (state) => state.MenuOpenReducer
    );
    const { isOperator, isAdmin } = useSelector(
        (state) => state.CompanyReducer || { isOperator: false, isAdmin: false }
    );
    
    // Só mostrar Dashboard se for ADMIN (não operador)
    const showDashboard = isAdmin && !isOperator;

    const isActive = (path) => {
        if (path === '/dashboard') {
            return location.pathname === '/dashboard';
        }
        return location.pathname.startsWith(path);
    };

    return (
        <Container
            className={menuOpen ? 'navbar-nav sidebar sidebar-dark accordion toggled' : 'navbar-nav sidebar sidebar-dark accordion'}
            id="accordionSidebar">

            {/* <!-- Sidebar - Brand --> */}
            <Link className="sidebar-brand d-flex align-items-center mt-4 mb-4 justify-content-center" to="/dashboard">
                <div className="sidebar-brand-icon">
                    <img width={menuOpen ? 70 : 140} src={logo} alt="Borracharia Major"/>
                </div>
            </Link>

            {/* <!-- Divider --> */}
            <hr className="sidebar-divider my-0"/>

            {/* <!-- Nav Item - Dashboard (apenas para ADMIN) --> */}
            {showDashboard && (
                <>
                    <li className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}>
                        <Link className="nav-link" to="/dashboard">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>Painel</span>
                        </Link>
                    </li>
                    <hr className="sidebar-divider"/>
                </>
            )}
            <li className={`nav-item ${isActive('/product') ? 'active' : ''}`}>
                <Link className='nav-link' to="/product">
                    <i className="fa fa-list"></i>
                    <span>Produtos</span>
                </Link>
            </li>
            <li className={`nav-item ${isActive('/stock-movement') ? 'active' : ''}`}>
                <Link className='nav-link' to="/stock-movement">
                    <i className="fa fa-exchange-alt"></i>
                    <span>Movimentações</span>
                </Link>
            </li>
            <li className={`nav-item ${isActive('/sales-list') ? 'active' : ''}`}>
                <Link className='nav-link' to="/sales-list">
                    <i className="fa fa-receipt"></i>
                    <span>Vendas Realizadas</span>
                </Link>
            </li>
            {showDashboard && (
                <li className={`nav-item ${isActive('/company') ? 'active' : ''}`}>
                    <Link className='nav-link' to="/company">
                        <i className="fa fa-building"></i>
                        <span>Empresas</span>
                    </Link>
                </li>
            )}
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="text-center mt-5">
                <button onClick={() => {
                    dispatch(actions.clickMenuOpen());
                }} className="rounded-circle border-0" id="sidebarToggle" aria-label="Toggle sidebar"></button>
            </div>
        </Container>
    )
}